import { render, staticRenderFns } from "./HubHeading.vue?vue&type=template&id=19251b6a&"
import script from "./HubHeading.vue?vue&type=script&lang=ts&"
export * from "./HubHeading.vue?vue&type=script&lang=ts&"
import style0 from "./HubHeading.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports